import script from "./rechargeGift.vue?vue&type=script&setup=true&lang=ts"
export * from "./rechargeGift.vue?vue&type=script&setup=true&lang=ts"

import "./rechargeGift.vue?vue&type=style&index=0&id=f8a8ddfc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8a8ddfc"]])

export default __exports__